// SemanticColors.jsx
// Define semantic mappings for each theme
const semanticThemes = {
  TealWhiteGrey: {
    colorFix1: " #e5e6e9",
    colorFix2: "#b5c4cd",
    colorFix3: "#386878",
    // Menu and Top header L shape
    // Left menu
    MenuBackground: "#2b6777",
    MenuBackgroundSearch: "#66B6BB",
    MenuBackgroundTextInActive: "#c8d8e4",
    MenuBackgroundTextActive: "#424242",

    // Left menu - search & dropdown
    MenuSearchPlaceholder: "#424242",
    MenuSearchTextDropdwonHeader: "#2b6777",
    MenuSearchTextDropdwonSubHeader: "#3f3f3f",
    MenuSearchDropdwonBackground: "#FFFFFF",

    // Top header
    HeaderBackground: "#2b6777",
    HeaderTextPrimary: "#c8d8e4",

    // Favourite Bar
    BarBackground: "#b5c4cd",
    BarTextHeader: "#2b6777",

    // Favourite Bar - Dropdown
    BarBackgroundDropdown: "#2b6777",
    BarBorderDropdown: "#46b7b2",
    BarActiveElementBackground: "#c8d8e4",
    BarText: "#2b6777",

    // favourite bar - search
    SearchBackground: "#FFFFFF",
    SearchPlaceholder: "#2b6777",
    SearchBarImage: "#FFFFFF",

    // favourite bar - search dropdown students
    searchDropdwonBackground: "#FFFFFF",
    SearchDropdownActiveElement: "#c8d8e4",
    SearchDropdwonText: "#2b6777",
    SearchDropdwonTextSubText: "#3f3f3f",

    // Table
    HeaderBase: "#c8d8e4",
    HeaderText: "#2b6777",

    // Table-Filter
    FilterBarText: "#2b6777",
    FilterBackground: "#2b6777",

    // Table-Pagination
    PaginationTopTextActive: "#000000",
    PaginationTopTextLink: "#228af2",

    // Table-ColumnHeaders (first row of table inner)
    ColumnHeadersText: "#000000",
    ColumnHeaderBackground: "#FFFFFF",

    // Table-Rows (odd / even)
    OddColumnBackground: "#FFFFFF",
    OddColumnText: "#3f3f3f",
    EvenColumnBackground: "#c8d8e4",
    EvenColumnText: "#3f3f3f",

    // table-PaginationBottom
    PaginationBottomText: "#2b6777",
    PaginationBottomBackgroundActive: "#2b6777",
    PaginationBottomBackgroundInActive: "#FFFFFF",

    // Column selection dropdown
    ColumnSelectionDropdownText: "#000000",
    ColumnSelectionDropdownBackground: "#FFFFFF",
    ColumnSelectionDropdowncheck: "#2b6777",
    ColumnSelectionDropdownUnCheck: "#FFFFFF",

    // Divs
    DivsShadows: "#00000040",

    // Div Header
    DivHeaderBackground: "#c8d8e4",
    DivHeaderText: "#2b6777",

    // Div Body
    DivBodyBackground: "#FFFFFF",
    DivBodyText: "#000000",

    // Dropdown
    DropdownBackground: "#FFFFFF",
    DropdwonLabelText: "#000000",
    DropdownPlaceholderText: "#808080",

    // Dropdown Options
    DropdwonOptionsBackground: "#c8d8e4",
    DropdwonText: "#3f3f3f",
    DropdownActiveElementBackground: "#46b7b2",

    
    // ============ PROFILE PAGE ============
    
    // Profile Page Background
    ProfilePageBackground: "#FFFFFF",
    
    // Profile Header Title
    ProfileHeaderTitleText: "#228af2",
    
    // Profile Card (Main Info Card)
    ProfileCardBackground: "#FFFFFF",
    ProfileCardBorder: "#e0e0e0",
    
    // Profile Avatar
    ProfileAvatarBackground: "#2b6777", // Red circle
    ProfileAvatarText: "#FFFFFF", // "DB" text
    ProfileAvatarBorder: "#e40000ff",
    
    // Profile Name
    // ProfileNameText: "#000000",
    
    // // Profile Info Labels (Staff Number, Username, etc.)
    // ProfileLabelText: "#666666",
    // ProfileValueText: "#000000",
    
    // // Change Password Section
    // ProfilePasswordSectionBackground: "#f5f5f5",
    // ProfilePasswordSectionBorder: "#e0e0e0",
    
    // // Change Password Header
    // ProfilePasswordHeaderText: "#000000",
    // ProfilePasswordSubHeaderText: "#666666",
    
    // // Password Input Fields
    // ProfileInputBackground: "#FFFFFF",
    // ProfileInputBorder: "#d0d0d0",
    // ProfileInputText: "#000000",
    // ProfileInputPlaceholder: "#999999",
    // ProfileInputLabelText: "#333333",
    
    // // Password Toggle Icon
    // ProfilePasswordToggleIcon: "#666666",
    
    // // Profile Buttons
    // ProfileButtonSaveBackground: "#FFFFFF",
    // ProfileButtonSaveText: "#000000",
    // ProfileButtonSaveBorder: "#000000",
    // ProfileButtonSaveHoverBackground: "#2b6777",
    // ProfileButtonSaveHoverText: "#FFFFFF",
    
    // ProfileButtonCancelBackground: "#FFFFFF",
    // ProfileButtonCancelText: "#000000",
    // ProfileButtonCancelBorder: "#000000",
    // ProfileButtonCancelHoverBackground: "#e0e0e0",
    
    // // Powered by DSE Text
    // ProfileFooterText: "#46b7b2",

    // ============ LOGIN PAGE ============
    
    // Login Page Background
    LoginPageBackground: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    LoginPageBackgroundSolid: "#e3f2fd", // Fallback solid color
    
    // Login Card/Container
    LoginCardBackground: "#FFFFFF",
    LoginCardBorder: "#e0e0e0",
    LoginCardShadow: "rgba(0, 0, 0, 0.3)",
    
    // Left Section (Illustration Side)
    LoginLeftSectionBackground: "linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)",
    LoginLeftSectionBackgroundSolid: "#f0f4ff",
    
    // Right Section (Form Side)
    LoginRightSectionBackground: "#f8f9ff",
    
    // PowerPrep Manager Title
    LoginTitleText: "#000000",
    LoginBrandNameText: "#6366f1", // Purple for "PowerPrep Manager"
    
    // Info Points (Prepare, Practice, Perform)
    LoginInfoHeaderText: "#000000",
    LoginInfoDescriptionText: "#666666",
    LoginInfoBulletColor: "#000000",
    
    // Semi-Circle Colors (using the extracted colors)
    LoginCircle1Background: "#e5e6e9", // Light beige/cream
    LoginCircle2Background: "#b5c4cd", // Light blue
    LoginCircle3Background: "#386878", // Dark teal
    
    // Form Labels
    LoginLabelText: "#333333",
    
    // Input Fields
    LoginInputBackground: "#FFFFFF",
    LoginInputBorder: "#e0e0e0",
    LoginInputBorderFocus: "#6366f1",
    LoginInputText: "#000000",
    LoginInputPlaceholder: "#999999",
    LoginInputIconColor: "#666666",
    
    // Checkbox
    LoginCheckboxBorder: "#d0d0d0",
    LoginCheckboxCheckedBackground: "#6366f1",
    LoginCheckboxText: "#666666",
    
    // Forgot Password Link
    LoginForgotPasswordText: "#6366f1",
    LoginForgotPasswordHoverText: "#5558e3",
    
    // Login Button
    LoginButtonBackground: "#6366f1",
    LoginButtonText: "#FFFFFF",
    LoginButtonHoverBackground: "#5558e3",
    LoginButtonBorder: "none",
    
    // Icons (User, Lock, Eye)
    LoginUserIconColor: "#666666",
    LoginLockIconColor: "#666666",
    LoginEyeIconColor: "#666666",
    QuestionContentBorder: "#DBE6EF",


    // ============ DPP SCHEDULING ============
    
    // Course Plan Cards
    DppCardBorder: "#ddd",
    DppCardBackground: "#ffffff",
    DppCardBackgroundCollapsed: "#f5f5f5",
    DppCardHeaderExpanded: "#e8e8e8",
    DppCardHeaderBorder: "#ddd",
    
    // Card Text Colors
    DppPlanNameText: "#000000",
    DppPlanDescText: "#666666",
    DppLabelText: "GrayText",
    DppValueText: "#000000",
    DppCheckmarkColor: "#4CAF50",
    
    // Input Fields
    DppInputBorder: "#d0d0d0",
    DppInputBackground: "#ffffff",
    DppInputText: "#000000",
    
    // Folder Dropdown
    DppDropdownBackground: "#ffffff",
    DppDropdownBorder: "#ccc",
    DppDropdownItemBorder: "#eee",
    DppDropdownHoverBackground: "rgb(212, 237, 218)",
    DppDropdownText: "#333333",
    DppDropdownSubText: "#666666",
    DppDropdownSearchBorder: "#f0f0f0",
    DppDropdownLevel4Background: "#f8f9fa",
    
    // Buttons
    DppButtonResetBackground: "#ffffff",
    DppButtonResetText: "#000000",
    DppButtonResetBorder: "#000000",
    DppButtonApplyBackground: "#2F2E40",
    DppButtonApplyBackgroundDisabled: "#cccccc",
    DppButtonApplyText: "#ffffff",
    
    // Dividers and Borders
    DppSectionBorder: "#eeeeee",
  },


  SageGreen: {
    // Menu and Top header L shape
    // Left menu
    MenuBackground: "#065150ff",
    MenuBackgroundSearch: "#116471ff",
    MenuBackgroundTextInActive: "#016e68ff",
    MenuBackgroundTextActive: "#FFFFFF",

    // Left menu - search & dropdown
    MenuSearchPlaceholder: "#e2e2e2ff",
    MenuSearchTextDropdwonHeader: "#2F2E40",
    MenuSearchTextDropdwonSubHeader: "#6A6A6A",
    MenuSearchDropdwonBackground: "#00726bff",

    // Top header
    HeaderBackground: "#065150ff",
    HeaderTextPrimary: "#FFFFFF",

    // Favourite Bar
    BarBackground: "#00da83ff",
    BarTextHeader: "#2F2E40",

    // Favourite Bar - Dropdown
    BarBackgroundDropdown: "#01ac73ff",
    BarBorderDropdown: "#13ddabff",
    BarActiveElementBackground: "#FFF1D1",
    BarText: "#2F2E40",

    // favourite bar - search
    SearchBackground: "#FFFFFF",
    SearchPlaceholder: "#2F2E40",
    SearchBarImage: "#068686ff",

    // favourite bar - search dropdown students
    searchDropdwonBackground: "#FFFFFF",
    SearchDropdownActiveElement: "#D6D6D6",
    SearchDropdwonText: "#2F2E40",
    SearchDropdwonTextSubText: "#6A6A6A",

    // Table
    HeaderBase: "#D6D6D6",
    HeaderText: "#2F2E40",

    // Table-Filter
    FilterBarText: "#2F2E40",
    FilterBackground: "#087043ff",

    // Table-Pagination
    PaginationTopTextActive: "#424242",
    PaginationTopTextLink: "#337AB7",

    // Table-ColumnHeaders (first row of table inner)
    ColumnHeadersText: "#424242",
    ColumnHeaderBackground: "#FFFFFF",

    // Table-Rows (odd / even)
    OddColumnBackground: "#FFFFFF",
    OddColumnText: "#6A6A6A",
    EvenColumnBackground: "#84e2e2ff",
    EvenColumnText: "#000000ff",

    // table-PaginationBottom
    PaginationBottomText: "#2F2E40",
    PaginationBottomBackgroundActive: "#2F2E40",
    PaginationBottomBackgroundInActive: "#FFFFFF",

    // Column selection dropdown
    ColumnSelectionDropdownText: "#424242",
    ColumnSelectionDropdownBackground: "#FFFFFF",
    ColumnSelectionDropdowncheck: "#2F2E40",
    ColumnSelectionDropdownUnCheck: "#FFFFFF",

    // Divs
    DivsShadows: "#00000040",

    // Div Header
    DivHeaderBackground: "#D6D6D6",
    DivHeaderText: "#424342",

    // Div Body
    DivBodyBackground: "#D6D6D6",
    DivBodyText: "#424342",

    // Dropdown
    DropdownBackground: "#19b058ff",
    DropdwonLabelText: "#424342",
    DropdownPlaceholderText: "#999999",

    // Dropdown Options
    DropdwonOptionsBackground: "#f7f7f7",
    DropdwonText: "#6a6a6a",
    DropdownActiveElementBackground: "#009402ff",

     // ============ PROFILE PAGE ============
    
    ProfilePageBackground: "#FFFFFF",
    
    ProfileHeaderTitleText: "#337AB7",
    
    ProfileCardBackground: "#FFFFFF",
    ProfileCardBorder: "#D6D6D6",
    
    ProfileAvatarBackground: "#00726bff",
    ProfileAvatarText: "#FFFFFF",
    ProfileAvatarBorder: "#FFFFFF",
    
  //   ProfileNameText: "#2F2E40",
    
  //   ProfileLabelText: "#6A6A6A",
  //   ProfileValueText: "#2F2E40",
    
  //   ProfilePasswordSectionBackground: "#f7f7f7",
  //   ProfilePasswordSectionBorder: "#D6D6D6",
    
  //   ProfilePasswordHeaderText: "#2F2E40",
  //   ProfilePasswordSubHeaderText: "#6A6A6A",
    
  //   ProfileInputBackground: "#FFFFFF",
  //   ProfileInputBorder: "#D6D6D6",
  //   ProfileInputText: "#2F2E40",
  //   ProfileInputPlaceholder: "#999999",
  //   ProfileInputLabelText: "#2F2E40",
    
  //   ProfilePasswordToggleIcon: "#6A6A6A",
    
  //   ProfileButtonSaveBackground: "#FFFFFF",
  //   ProfileButtonSaveText: "#2F2E40",
  //   ProfileButtonSaveBorder: "#2F2E40",
  //   ProfileButtonSaveHoverBackground: "#065150ff",
  //   ProfileButtonSaveHoverText: "#FFFFFF",
    
  //   ProfileButtonCancelBackground: "#FFFFFF",
  //   ProfileButtonCancelText: "#2F2E40",
  //   ProfileButtonCancelBorder: "#2F2E40",
  //   ProfileButtonCancelHoverBackground: "#D6D6D6",
    
  //   ProfileFooterText: "#13ddabff",

   // ============ LOGIN PAGE ============
    
    LoginPageBackground: "linear-gradient(135deg, #065150ff 0%, #00da83ff 100%)",
    LoginPageBackgroundSolid: "#065150ff",
    
    LoginCardBackground: "#065150ff",
    LoginCardBorder: "#D6D6D6",
    LoginCardShadow: "rgba(0, 0, 0, 0.3)",
    
    LoginLeftSectionBackground: "linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%)",
    LoginLeftSectionBackgroundSolid: "#e8f5e9",
    
    LoginRightSectionBackground: "#f5f5f5",
    
    LoginTitleText: "#2F2E40",
    LoginBrandNameText: "#00da83ff",
    
    LoginInfoHeaderText: "#2F2E40",
    LoginInfoDescriptionText: "#6A6A6A",
    LoginInfoBulletColor: "#2F2E40",
    
    LoginCircle1Background: "#e8f5e9",
    LoginCircle2Background: "#84e2e2ff",
    LoginCircle3Background: "#065150ff",
    
    LoginLabelText: "#2F2E40",
    
    LoginInputBackground: "#FFFFFF",
    LoginInputBorder: "#D6D6D6",
    LoginInputBorderFocus: "#00da83ff",
    LoginInputText: "#2F2E40",
    LoginInputPlaceholder: "#999999",
    LoginInputIconColor: "#6A6A6A",
    
    LoginCheckboxBorder: "#D6D6D6",
    LoginCheckboxCheckedBackground: "#00da83ff",
    LoginCheckboxText: "#6A6A6A",
    
    LoginForgotPasswordText: "#00da83ff",
    LoginForgotPasswordHoverText: "#01ac73ff",
    
    LoginButtonBackground: "#065150ff",
    LoginButtonText: "#FFFFFF",
    LoginButtonHoverBackground: "#00da83ff",
    LoginButtonBorder: "none",
    
    LoginUserIconColor: "#6A6A6A",
    LoginLockIconColor: "#6A6A6A",
    LoginEyeIconColor: "#6A6A6A",
  },

  DarkMode: {
    // Menu and Top header L shape
    // Left menu
    MenuBackground: "#1a1a1a",
    MenuBackgroundSearch: "#ff5252",
    MenuBackgroundTextInActive: "#888888",
    MenuBackgroundTextActive: "#FFFFFF",

    // Left menu - search & dropdown
    MenuSearchPlaceholder: "#ddddddff",
    MenuSearchTextDropdwonHeader: "#FFFFFF",
    MenuSearchTextDropdwonSubHeader: "#AAAAAA",
    MenuSearchDropdwonBackground: "#2d2d2d",

    // Top header
    HeaderBackground: "#1a1a1a",
    HeaderTextPrimary: "#FFFFFF",

    // Favourite Bar
    BarBackground: "#ffa726",
    BarTextHeader: "#1a1a1a",

    // Favourite Bar - Dropdown
    BarBackgroundDropdown: "#ff9800",
    BarBorderDropdown: "#f57c00",
    BarActiveElementBackground: "#2d2d2d",
    BarText: "#FFFFFF",

    // favourite bar - search
    SearchBackground: "#FFFFFF",
    SearchPlaceholder: "#888888",
    SearchBarImage: "#2d2d2d",

    // favourite bar - search dropdown students
    searchDropdwonBackground: "#2d2d2d",
    SearchDropdownActiveElement: "#404040",
    SearchDropdwonText: "#FFFFFF",
    SearchDropdwonTextSubText: "#AAAAAA",

    // Table
    HeaderBase: "#2d2d2d",
    HeaderText: "#FFFFFF",

    // Table-Filter
    FilterBarText: "#FFFFFF",
    FilterBackground: "#ff9800",

    // Table-Pagination
    PaginationTopTextActive: "#E0E0E0",
    PaginationTopTextLink: "#64b5f6",

    // Table-ColumnHeaders (first row of table inner)
    ColumnHeadersText: "#2d2d2d",
    ColumnHeaderBackground: "#FFFFFF",

    // Table-Rows (odd / even)
    OddColumnBackground: "#1e1e1e",
    OddColumnText: "#CCCCCC",
    EvenColumnBackground: "#262626",
    EvenColumnText: "#CCCCCC",

    // table-PaginationBottom
    PaginationBottomText: "#FFFFFF",
    PaginationBottomBackgroundActive: "#ff9800",
    PaginationBottomBackgroundInActive: "#2d2d2d",

    // Column selection dropdown
    ColumnSelectionDropdownText: "#E0E0E0",
    ColumnSelectionDropdownBackground: "#2d2d2d",
    ColumnSelectionDropdowncheck: "#ff9800",
    ColumnSelectionDropdownUnCheck: "#1a1a1a",

    // Divs
    DivsShadows: "#00000080",

    // Div Header
    DivHeaderBackground: "#2d2d2d",
    DivHeaderText: "#FFFFFF",

    // Div Body
    DivBodyBackground: "#1e1e1e",
    DivBodyText: "#E0E0E0",

    // Dropdown
    DropdownBackground: "#2d2d2d",
    DropdwonLabelText: "#FFFFFF",
    DropdownPlaceholderText: "#888888",

    // Dropdown Options
    DropdwonOptionsBackground: "#1e1e1e",
    DropdwonText: "#CCCCCC",
    DropdownActiveElementBackground: "#404040",

    // ============ PROFILE PAGE ============
    
    ProfilePageBackground: "#1e1e1e",
    
    ProfileHeaderTitleText: "#64b5f6",
    
    ProfileCardBackground: "#2d2d2d",
    ProfileCardBorder: "#404040",
    
    ProfileAvatarBackground: "#2d2d2d",
    ProfileAvatarText: "#FFFFFF",
    ProfileAvatarBorder: "#404040",
    
    // ProfileNameText: "#E0E0E0",
    
    // ProfileLabelText: "#AAAAAA",
    // ProfileValueText: "#E0E0E0",
    
    // ProfilePasswordSectionBackground: "#1a1a1a",
    // ProfilePasswordSectionBorder: "#404040",
    
    // ProfilePasswordHeaderText: "#E0E0E0",
    // ProfilePasswordSubHeaderText: "#AAAAAA",
    
    // ProfileInputBackground: "#2d2d2d",
    // ProfileInputBorder: "#404040",
    // ProfileInputText: "#E0E0E0",
    // ProfileInputPlaceholder: "#888888",
    // ProfileInputLabelText: "#E0E0E0",
    
    // ProfilePasswordToggleIcon: "#AAAAAA",
    
    // ProfileButtonSaveBackground: "#2d2d2d",
    // ProfileButtonSaveText: "#E0E0E0",
    // ProfileButtonSaveBorder: "#E0E0E0",
    // ProfileButtonSaveHoverBackground: "#ffa726",
    // ProfileButtonSaveHoverText: "#1a1a1a",
    
    // ProfileButtonCancelBackground: "#2d2d2d",
    // ProfileButtonCancelText: "#E0E0E0",
    // ProfileButtonCancelBorder: "#404040",
    // ProfileButtonCancelHoverBackground: "#404040",
    
    // ProfileFooterText: "#ffa726",

    // ============ LOGIN PAGE ============
    
    LoginPageBackground: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
    LoginPageBackgroundSolid: "#1a1a1a",
    
    LoginCardBackground: "#8f3232ff",
    LoginCardBorder: "#404040",
    LoginCardShadow: "rgba(0, 0, 0, 0.5)",
    
    LoginLeftSectionBackground: "linear-gradient(135deg, #1e1e1e 0%, #2d2d2d 100%)",
    LoginLeftSectionBackgroundSolid: "#1e1e1e",
    
    LoginRightSectionBackground: "#262626",
    
    LoginTitleText: "#E0E0E0",
    LoginBrandNameText: "#ffa726",
    
    LoginInfoHeaderText: "#E0E0E0",
    LoginInfoDescriptionText: "#AAAAAA",
    LoginInfoBulletColor: "#E0E0E0",
    
    LoginCircle1Background: "#404040",
    LoginCircle2Background: "#555555",
    LoginCircle3Background: "#1a1a1a",
    
    LoginLabelText: "#E0E0E0",
    
    LoginInputBackground: "#1e1e1e",
    LoginInputBorder: "#404040",
    LoginInputBorderFocus: "#ffa726",
    LoginInputText: "#E0E0E0",
    LoginInputPlaceholder: "#888888",
    LoginInputIconColor: "#AAAAAA",
    
    LoginCheckboxBorder: "#404040",
    LoginCheckboxCheckedBackground: "#ffa726",
    LoginCheckboxText: "#AAAAAA",
    
    LoginForgotPasswordText: "#ffa726",
    LoginForgotPasswordHoverText: "#ff9800",
    
    LoginButtonBackground: "#ffa726",
    LoginButtonText: "#1a1a1a",
    LoginButtonHoverBackground: "#ff9800",
    LoginButtonBorder: "none",
    
    LoginUserIconColor: "#AAAAAA",
    LoginLockIconColor: "#AAAAAA",
    LoginEyeIconColor: "#AAAAAA",
  },
};

// Current semantic theme - CHANGED TO TealWhiteGrey
let currentSemanticTheme = "TealWhiteGrey";

// Function to apply semantic theme
const applySemanticTheme = (themeName) => {
  if (!semanticThemes[themeName]) {
    console.error(`Theme "${themeName}" not found`);
    return;
  }

  currentSemanticTheme = themeName;
  const theme = semanticThemes[themeName];

  if (typeof document !== "undefined") {
    Object.entries(theme).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value);
    });
  }

  // Save to localStorage
  localStorage.setItem("semanticTheme", themeName);

  console.log(`✅ Theme applied: ${themeName}`);
};

// Initialize with saved theme or default - CHANGED TO TealWhiteGrey
if (typeof document !== "undefined") {
  const savedTheme =
    localStorage.getItem("semanticTheme") || currentSemanticTheme;
  applySemanticTheme(savedTheme);
}

export { semanticThemes, applySemanticTheme, currentSemanticTheme };
export default semanticThemes[currentSemanticTheme];
